import store from '@/store'

export default async (to, _from, next) => {
  const user = store.getters['auth/user']

  if (user.role !== 'fso') {
    next({ name: `${user.role}.dashboard` })
  } else {
    next()
  }
}
